// TODO: make these selectors
import {createSelector} from "reselect";

export const NAMESPACE = "events";

export function selectEvents(state) {
  return state[NAMESPACE]?.events;
}

export const eventIdsMatch = (idA, idB) => idA == idB; // `==` is intentional since often times eventId is passed as a string or a number
export const objectHasEventId = ({eventId: id}, eventId) => eventIdsMatch(eventId, id);
export const createEventIdMatcher = (eventId) => (obj) => objectHasEventId(obj, eventId);

/**
 * look through an array of objects for a match based on prop `eventId`
 * @param list
 * @param eventId
 * @returns {*}
 */
export function getByEventId(list = [], eventId) {
  return list.find(createEventIdMatcher(eventId));
}
export function filterByEventId(list = [], eventId) {
  return list.filter(createEventIdMatcher(eventId));
}

export function getFulfillmentMethodsForEvent(events, eventId) {
  const event = getByEventId(events, eventId);
  return event?.fulfillmentMethods;
}

export function getFulfillmentMethodForEvent(events, eventId, ticketType) {
  return (getFulfillmentMethodsForEvent(events, eventId) || [])
    .find(({ticketMedium}) => ticketMedium === ticketType);
}

export const selectEventMetadata = createSelector(
  (state) => state?.eventMetaData,
  (eventMetaData) => eventMetaData
);

/**
 * Deprecated.
 * @type {OutputSelector<unknown, *, (res: unknown) => *>}
 */
export const eventIdSelector = createSelector(
  selectEvents,
  (events = []) => events[0]?.eventId
);
export const selectMetadataVenue = createSelector(
  selectEventMetadata,
  (eventMetaData) => eventMetaData?.venue
);
export const selectEventOriginCountry = createSelector(
  selectEventMetadata,
  (eventMetaData) => eventMetaData?.venue?.country || 'US'
);
export const selectEventOriginState = createSelector(
  selectEventMetadata,
  (eventMetaData) => eventMetaData?.venue?.state || ''
);
export const selectLocalLaws = createSelector(
  selectEventMetadata,
  (eventMetaData) => eventMetaData?.venue?.localLaws || ''
);
export const isGAEventSelector = createSelector(
  [selectMetadataVenue],
  (venue) => venue?.generalAdmissionIndicator
);
export const venueConfigIdSelector = createSelector(
  selectMetadataVenue,
  (venue) => venue?.venueConfigId
);

export const selectCurrencyCode = createSelector(
  selectEventMetadata,
  ({currencyCode} = {}) => currencyCode
);

export const selectIntegratedEventInfoForEvent = createSelector(
  selectEvents,
  ({events}) => (eventId) => getByEventId(events, eventId)?.integratedEventInfo || {}
);
export const selectIsSeatsRequiredForEvent = createSelector(
  selectIntegratedEventInfoForEvent,
  (getIntegratedInfo) => (eventId) => getIntegratedInfo(eventId).isSeatsRequired || false
);
export const selectIsSRSRequiredEvent = createSelector(
  selectIntegratedEventInfoForEvent,
  (getIntegratedInfo) => (eventId) => getIntegratedInfo(eventId).isSRSRequired || false
);

// These selectors really shouldn't be used at all. they can only make the selection of the first event and therefore could be inaccurate for multi event
export const selectIntegratedEventInfo = createSelector(
  selectEvents,
  (events = []) => events[0]?.integratedEventInfo || {}
);
export const isSeatsRequiredSelector = createSelector(
  selectIntegratedEventInfo,
  (integratedEventInfo) => integratedEventInfo.isSeatsRequired || false
);
export const isSRSRequiredSelector = createSelector(
  selectIntegratedEventInfo,
  (integratedEventInfo) => integratedEventInfo.isSRSRequired || false
);
